module.exports = __webpack_public_path__ + "img/center-logo.ae6cda56.png";